var FileUtils = /** @class */ (function () {
    function FileUtils() {
    }
    FileUtils.showSaveFile = function (responseOrBlob, fileName) {
        var blobData = responseOrBlob;
        if (fileName === undefined) {
            var response = responseOrBlob;
            fileName = this.getAttachmentFileNameFromResponse(response);
            blobData = response.data;
        }
        var blobReference = window.URL.createObjectURL(new Blob([blobData]));
        var link = document.createElement('a');
        link.href = blobReference;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobReference);
    };
    FileUtils.getAttachmentFileNameFromResponse = function (response) {
        var disposition = response.headers["content-disposition"];
        if (disposition && disposition.startsWith('attachment')) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                return matches[1].replace(/['"]/g, '');
            }
        }
        var fileNameValue = response.headers["x_filename"];
        if (fileNameValue) {
            return fileNameValue;
        }
        throw Error("Filename not found. Make sure the response contains a content-disposition / x_filename header, and that your CORS policy exposes this header.");
    };
    return FileUtils;
}());
export default FileUtils;
